import Visiferm		from "./circuits/visiferm.js";
import sleep		from "sleep";

class DissolvedOxygenSensor extends Visiferm {
  constructor(...args) {
    super(...args);

    this.id = "-";
    this.value = "-";
    this.status = "uninitialized";
    this.calibrationStatus = "-";
    this.internalTemperature = "N/A";
    this.temperatureCompenstationStatus = "auto";
  }
  async initialize() {
    try {
      await sleep(1500);
      this.id = await this.getSensorIdentification();
      await this.setPMC1PhysicalUnit(0x20);
      //this.calibrationStatus = await this.getCalibrationStatus();
      this.status = "ok";
    } catch(e) {
      this.status = "failed: " + e;
      throw e;
    }
  }
  async update() {
    //await sleep(1500);
    this.value = Math.round(await this.getDissolvedOxygen()*10)/10;
    this.internalTemperature = Math.round(await this.getTemperature()*100)/100;
    this.calibrationStatus = await this.getCalibrationStatus();
  }
  async clearCalibration() {
    throw "not implemented";
  }
  toJSON() {
    return({
      id: this.id,
      status: this.status,
      calibrationStatus: this.calibrationStatus,
      value: this.value,
      internalTemperature: this.internalTemperature,
      temperatureCompenstationStatus: this.temperatureCompenstationStatus
    });
  }
}

export default DissolvedOxygenSensor;